import type { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/utils";

type ProductCardCompactProps = {
  image: ReactNode;
  label: ReactNode;
  subLabel: string;
  price: string;
  outOfStock?: boolean;
  padding?: boolean;
  children?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export const ProductCardCompact: FC<ProductCardCompactProps> = ({
  image,
  label,
  subLabel,
  price,
  outOfStock,
  padding = true,
  children,
  ...props
}) => (
  <li
    className={cn(
      "flex h-fit min-h-30 w-full gap-2 bg-white md:gap-3",
      "min-h-39",
      {
        "p-4 md:p-6": padding,
      },
      props.className,
    )}
  >
    <div className="aspect-5/7 max-w-[5rem] min-w-[5rem]">{image}</div>
    <div className="flex w-full flex-col justify-between gap-1 pb-2 md:gap-2">
      <div>
        <div className="flex justify-between gap-0">
          <div className="!bb-text-body text-grey-4 line-clamp-2 decoration-0">
            {label}
          </div>
          <p
            className={cn({
              "text-gray-2 line-through": outOfStock,
              "text-grey-4": !outOfStock,
            })}
          >
            {price}
          </p>
        </div>
        <p className="!bb-text-tiny text-gray-2">{subLabel}</p>
      </div>

      <div
        className={cn(
          "flex flex-wrap items-center justify-between",
          "min-h-10 items-end gap-2 md:min-h-12",
        )}
      >
        {children}
      </div>
    </div>
  </li>
);

ProductCardCompact.displayName = "ProductCardCompact";
